/*
 * Filename: icon-picker-controllers.ts
 * Description: Icon Picker controller.
 */

import { CQAPIService } from '../../services/http-api.service';
import { CQAppConstant } from '../../app-constants';
import { CQAppStore } from '../../store/cq-app-store';


export default class IconPickerController {
    private readonly cqAPIService: CQAPIService;
    constructor() {
        this.cqAPIService = new CQAPIService();
    }

    /**
     * @memberof IconPickerController
     */
    public async getGroupWiseIconList(iconGroupUrls: string[]) {
        try {
            const actionSprite = await fetch(iconGroupUrls[0]);
            const actionSpriteXml = await actionSprite.text();
            const customSprite = await fetch(iconGroupUrls[1]);
            const customSpriteXml = await customSprite.text();
            const doctypeSprite = await fetch(iconGroupUrls[2]);
            const doctypeSpriteXml = await doctypeSprite.text();
            const standardSprite = await fetch(iconGroupUrls[3]);
            const standardSpriteXml = await standardSprite.text();
            const utilityType = await fetch(iconGroupUrls[4]);
            const utilityTypeXml = await utilityType.text();
            const actionSpriteIcons = this.getICONInformationFromXmlDocument(actionSpriteXml);
            const customSpriteIcons = this.getICONInformationFromXmlDocument(customSpriteXml);
            const doctypeSpriteIcons = this.getICONInformationFromXmlDocument(doctypeSpriteXml);
            const standardSpriteIcons = this.getICONInformationFromXmlDocument(standardSpriteXml);
            const utilityTypeIcons = this.getICONInformationFromXmlDocument(utilityTypeXml);
            return { actionSpriteIcons, customSpriteIcons, doctypeSpriteIcons, standardSpriteIcons, utilityTypeIcons };
        } catch (error : any) {
            CQAppStore.loader.setVisibility(false);
            const errorObj = {
                errorType: CQAppConstant.ERROR_CUSTOM,
                errorMessage: error.error ? error.error : error.message,
                errorStatus: error.status,
                componentName: ''
            };
            CQAppStore.error.dispatchError(errorObj);
        }
    }


    public getICONInformationFromXmlDocument(documentString: string) {
        const iconList: string[] = [];
        const parser = new DOMParser();
        const xml = parser.parseFromString(documentString, 'text/xml');
        if (xml) {
            const nodeData = xml.querySelectorAll('symbol');
            if (nodeData) {
                nodeData.forEach((node: any) => {
                    iconList.push(node.getAttribute('id'));
                });
            }
        }
        return iconList;
    }

}
